import {Model, ModelInstance} from './Common';

class DocumentInstance extends ModelInstance {
  company = '';
  createdAt = '';
  constructor(document) {
    super(document);
    this.filename = document.filename;
    this.company = document.companyId || '';
    this.documentType = document.documentType?.id || document.documentType || null;
    this.documentTypeLabel = document.documentType?.labelFr || '';
    this.createdAt = document.createdAt;
    this.createdAtFormated = document.createdAt
      ? `${new Date(document.createdAt).toLocaleDateString()}`
      : '';
  }
}

export class Document extends Model {
  getMany = documents => documents.map(document => new DocumentInstance(document));
  getOne = document => new DocumentInstance(document);
}
